import { Inline } from '@/ui';
import { FormCard } from '@/ui/composites/FormCard';
import type { SpacingToken } from '@/theme/tokens';
import type { FormCardProps } from '@/ui/composites/FormCard';
import type { ReactElement, ReactNode } from 'react';

type PanelProps = Omit<FormCardProps, 'footer'> & {
  actions?: ReactNode;
  actionsAlign?: 'flex-start' | 'center' | 'flex-end' | 'space-between';
  actionsGap?: SpacingToken;
};

export const Panel = ({
  actions,
  actionsAlign = 'flex-end',
  actionsGap = 'sm',
  border = true,
  gap = 'md',
  contentGap = 'md',
  footerGap = 'md',
  surfaceVariant = 'settings',
  ...rest
}: PanelProps): ReactElement => {
  const footer = actions ? (
    <Inline gap={actionsGap} justify={actionsAlign}>
      {actions}
    </Inline>
  ) : undefined;
  return (
    <FormCard
      {...rest}
      border={border}
      footer={footer}
      gap={gap}
      contentGap={contentGap}
      footerGap={footerGap}
      surfaceVariant={surfaceVariant}
    />
  );
};
